module.exports = __webpack_public_path__ + "static/media/office-work-desk-computer-81363.43b253b4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/office-work-desk-computer-81363.jpeg
// module id = 787
// module chunks = 0